import React from 'react';
import ScreenSelect from 'components/ScreensPanelItem/components/Shared/ScreenSelect';
import { Option } from 'components/ScreensPanelItem/components/Shared/ScreenSelect/models';
import * as Constants from 'const';
import { ScreenFormatType as SFtype } from 'const';
import { getScreenFormatLabel } from 'utils/screens/getScreenFormatLabel';
import { isCustomScreenFormatType } from 'utils/screens/isCustomScreenFormat';

type Props = {
  className?: string;
  customHeight?: number;
  customWidth?: number;
  formatType?: SFtype;
  isTooltipDisabled?: boolean;
  onFormateChange(formatType: SFtype): void;
  showCustomFormatOnlyWhenItIsActive?: boolean;
  disabled?: boolean;
  dataTestId?: string;
};

const ScreenFormatType: React.FunctionComponent<Props> = ({
  className,
  customHeight,
  customWidth,
  formatType,
  isTooltipDisabled = true,
  onFormateChange,
  showCustomFormatOnlyWhenItIsActive = false,
  disabled = false,
  dataTestId = 'screenFormatType',
}) => {
  const options: Option[] = Constants.PredefinedScreenFormats.map(format => ({
    value: format.type,
    label: getScreenFormatLabel(format),
  }));
  const customFormatOption = {
    value: Constants.ScreenFormatType.CUSTOM,
    label: getScreenFormatLabel({ type: Constants.ScreenFormatType.CUSTOM, width: customWidth, height: customHeight }),
  };

  showCustomFormatOnlyWhenItIsActive
    ? isCustomScreenFormatType(formatType) && options.push(customFormatOption)
    : options.push(customFormatOption);

  const handleChange = (option: Option): void => {
    const selectedFormatType = option.value as Constants.ScreenFormatType;

    if (selectedFormatType === formatType) {
      return;
    }

    onFormateChange(selectedFormatType);
  };

  const activeOption = options.find(option => option.value === formatType);

  return (
    <ScreenSelect
      activeOption={activeOption}
      disabled={disabled}
      className={className}
      isTooltipDisabled={isTooltipDisabled}
      onChange={handleChange}
      options={options}
      dataTestId={`${dataTestId}-select`}
    />
  );
};

export default ScreenFormatType;
